import { useId } from "react";

import { ControlledTextInput } from "@/components/FormInputs";
import { DateTimeInput } from "@/components/inputs/DateTimeInput";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { AddPollInput, UpdatePollInput } from "@/gen/graphql";
import { cn } from "@/utils";
import { cx } from "@/utils/cx";

export type PollT = AddPollInput | UpdatePollInput;

export const PollInput = ({
    poll,
    setPoll,
    label,
    className,
}: {
    poll: PollT;
    setPoll: (poll: PollT) => void;
    label?: string;
    className?: string;
}) => {
    const id = useId();
    return (
        <div className={cx("flex flex-col gap-2", className)}>
            {label ? <Label htmlFor={id}>{label}</Label> : null}

            <div className={cn("flex flex-col space-y-4 border p-4")}>
                <ControlledTextInput
                    id="poll-title"
                    className="text-black"
                    label={"Poll title"}
                    value={poll?.title}
                    onValue={title => setPoll({ ...poll, title })}
                />
                <DateTimeInput
                    label="End at"
                    value={new Date(poll?.endAt)}
                    onValue={endAt => setPoll({ ...poll, endAt: endAt.toISOString() })}
                />
                {poll.options.map((option, index) => (
                    <div key={index} className="flex flex-row items-end gap-4">
                        <ControlledTextInput
                            id={`poll-option-${index}`}
                            label={`Option ${index + 1}`}
                            value={option.text}
                            autoFocus
                            onValue={text =>
                                setPoll({
                                    ...poll,
                                    options: poll.options.map((o, i) =>
                                        i === index ? { ...o, text } : o
                                    ),
                                })
                            }
                            placeholder="Option text"
                        />
                        <Button
                            onClick={() =>
                                setPoll({
                                    ...poll,
                                    options: poll.options.filter((_, i) => i !== index),
                                })
                            }
                        >
                            Remove
                        </Button>
                    </div>
                ))}
                <Button
                    className="w-1/4"
                    onClick={() =>
                        setPoll({
                            ...poll,
                            options: [
                                ...poll.options,
                                {
                                    text: "",
                                },
                            ],
                        })
                    }
                >
                    Add option
                </Button>
            </div>
        </div>
    );
};
